import gql from 'graphql-tag';

export default gql`
  mutation createIntegration($integration: IntegrationInput!) {
    createIntegration(integration: $integration) {
      _id
    }
  }
`;
